module.exports = "/_next/static/images/Iso27017Badge@2x-f6fb4bc962b4b9592d3c371664814e00.png";